import {Routes} from '@angular/router';

export const selectionRecommendationRoutes: Routes = [
  {
    path: 'selectionRecommendation',
    loadComponent: () => import('./selection-recommendation.component').then(m => m.SelectionRecommendationComponent),
    data: { title: '甄选橱窗' },
  },
];
